var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2917 12.2917V16.875H16.875V12.2917H12.2917ZM11.0417 12.1667C11.0417 11.5453 11.5453 11.0417 12.1667 11.0417H17C17.6213 11.0417 18.125 11.5453 18.125 12.1667V17C18.125 17.6213 17.6213 18.125 17 18.125H12.1667C11.5453 18.125 11.0417 17.6213 11.0417 17V12.1667Z",
    fill: "#4B5054"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.125 12.2917V16.875H7.70833V12.2917H3.125ZM1.875 12.1667C1.875 11.5453 2.37868 11.0417 3 11.0417H7.83333C8.45465 11.0417 8.95833 11.5453 8.95833 12.1667V17C8.95833 17.6213 8.45465 18.125 7.83333 18.125H3C2.37868 18.125 1.875 17.6213 1.875 17V12.1667Z",
    fill: "#4B5054"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2917 3.125V7.70833H16.875V3.125H12.2917ZM11.0417 3C11.0417 2.37868 11.5453 1.875 12.1667 1.875H17C17.6213 1.875 18.125 2.37868 18.125 3V7.83333C18.125 8.45465 17.6213 8.95833 17 8.95833H12.1667C11.5453 8.95833 11.0417 8.45465 11.0417 7.83333V3Z",
    fill: "#4B5054"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.125 3.125V7.70833H7.70833V3.125H3.125ZM1.875 3C1.875 2.37868 2.37868 1.875 3 1.875H7.83333C8.45465 1.875 8.95833 2.37868 8.95833 3V7.83333C8.95833 8.45465 8.45465 8.95833 7.83333 8.95833H3C2.37868 8.95833 1.875 8.45465 1.875 7.83333V3Z",
    fill: "#4B5054"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.2139b54a9b5d14263e0d0f48f8e57586.svg";
export { ForwardRef as ReactComponent };